module.exports = __webpack_public_path__ + "static/media/ricardo-perez-checkmark.4b6fef90.svg";